import Listings from '../components/Listings';
import Leads from '../components/Leads';

const homeRoutes = [
  {
    path: '/home/listings',
    name: 'Listings',
    key: 'hrlistings',
    component: Listings,
    exact: false,
  },
  {
    path: '/home/leads',
    name: 'Leads',
    key: 'hrLeads',
    component: Leads,
  },
];

export default homeRoutes;



// WEBPACK FOOTER //
// ./src/routes/homeRoutes.js